import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-button-new',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule, PipesModule],
  templateUrl: './button-new.component.html',
  styleUrls: ['./button-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonNewComponent {
  public languageKey = LanguageKey;
}
